import { lazy } from 'react';

// Hidden page imports
// Exported from a separate file to enable fast refresh during development

export const SettingsPage = lazy(() => import('../Pages/Settings'));
export const HiddenPageIndexPage = lazy(() => import('../Pages/HiddenPagesIndexPage'));
export const DynamicLineNormalisationReport = lazy(
    () => import('../Pages/DynamicLineNormalisationReport/DynamicLineNormalisationReport'),
);
export const PersonalizedGallery = lazy(() => import('../Pages/PersonalizedGallery/PersonalizedGallery'));
export const AdaptToProductPage = lazy(() => import('../Pages/AdaptToProductPage/AdaptToProductPage'));
export const PreviewCardVisualizationsPage = lazy(() => import('../Pages/PreviewCardVisualizationsPage'));
export const EditImagePageV0 = lazy(() => import('../Pages/EditImage/v0/editImagePageV0'));
export const CompositionAutoLayoutPage = lazy(() => import('../Pages/CompositionAutoLayoutPage'));
export const DiamondParityPage = lazy(() => import('../Pages/DiamondParity/DiamondParityPage'));
export const DiamondUrlConverterPage = lazy(() => import('../Pages/DiamondParity/DiamondUrlConverterPage'));
export const DiamondParityStaticPage = lazy(() => import('../Pages/DiamondParity/DiamondParityStaticPage'));
export const DiamondParityDynamicPage = lazy(() => import('../Pages/DiamondParity/DiamondParityDynamicPage'));
export const DiamondParityAutoLayoutPage = lazy(() => import('../Pages/DiamondParity/DiamondParityAutoLayoutPage'));
export const DesignJobPage = lazy(() => import('../Pages/DesignJobPage').then((m) => ({ default: m.DesignJobPage })));
